import {
    mapValues,
    findKey,
    get,
    sortBy,
    includes
} from 'lodash';

import { getLegalStatusApi } from '../../apis/core_basic_api/legal_status_config';
import { legalSettings } from '@patsnap-utils/biz';
import { proxyDefaultValue } from '../../componentZPrefaceProxy/proxyDefaultValue';

const backendFieldsMap = {
    'LEGAL_STATUS': 'legalStatus',
    'SIMPLE_LEGAL_STATUS': 'simpleLegalStatus',
    'LEGAL_EVENT': 'legalEvents',
    'ENTRY_COUNTRY_STATUS': 'entryCountryStatus',
    'ENTRY_COUNTRY_LEGAL_STATUS': 'entryCountryLegalStatus'
};

// 兼容移除zPREFACE
let legalConfig;

export const getLegalConfig = () => {
    return legalConfig || proxyDefaultValue.legalConfig;
};

export const setLegalConfig = (config) => {
    legalConfig = config;
};

const ENTRY_COUNTRY_LS_CODE = ['1', '2', '3', '8', '11', '12', '17', '18', '13', '14', '15', '16', '21', '22', '23', '24', '30', '19', '20', '25']
const ENTRY_COUNTRY_SLS_CODE = ['0', '1', '2', '999']

export async function initLegalStatus() {
    const legalConfig = getLegalConfig();
    if (legalConfig && legalConfig.length) {
        return { legalConfig };
    }
    try {
        const legalStatusConfig = await getLegalStatusApi();
        let result = [];
        mapValues(legalStatusConfig, (value, key) => {
            mapValues(value, (codeValue, code) => {
                result.push(
                    {
                        codeType: findKey(backendFieldsMap, o => o === key),
                        label: get(codeValue, 'title', {}),
                        color: get(codeValue, 'color', ''),
                        desc: get(codeValue, 'desc', {}),
                        isEpStatus: get(codeValue, 'ep_code', false),
                        epLabel: get(codeValue, 'ep_legal_group_title', {}),
                        epDesc: get(codeValue, 'ep_legal_group_desc', {}),
                        isEntryCountryLS: includes(ENTRY_COUNTRY_LS_CODE, code),
                        isEntryCountrySlS: includes(ENTRY_COUNTRY_SLS_CODE, code),
                        relatedCode: get(codeValue, 'related_code', []),
                        code,
                    });
            });
        });
        try {
            // 不知为什么会出错
            legalSettings(document, result);
        } catch (err) {
            console.error(err);
        }
        // 排序是为了确保simple legal status在legal status后面

        const config = sortBy(result, 'codeType');
        setLegalConfig(config);

        return {
            legalConfig: config,
        };
    } catch (err) {
        throw err;
    }

}
